import { z } from 'zod'

export const reportSearchSchema = z.object({
  status: z
    .enum(['queued', 'generating', 'ready', 'partial', 'failed', 'expired'])
    .optional()
    .catch(undefined),
  delivery_status: z
    .enum(['sending', 'succeeded', 'failed', 'unknown'])
    .optional()
    .catch(undefined),
  profile_key: z.string().max(100).optional().catch(undefined),
  producer: z.string().max(40).optional().catch(undefined),
  instance_id: z.coerce
    .number()
    .int()
    .positive()
    .max(Number.MAX_SAFE_INTEGER)
    .optional()
    .catch(undefined),
  period_from: z.string().datetime().optional().catch(undefined),
  period_to: z.string().datetime().optional().catch(undefined),
  offset: z.coerce
    .number()
    .int()
    .min(0)
    .max(100000)
    .optional()
    .catch(undefined),
})
export const reportDetailSearchSchema = z.object({
  return_search: reportSearchSchema.optional().catch(undefined),
})
